<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Geographical and Environmental Science Society</h3></header>
            <img src="assets/img/geographical_and_environmental_science_society.jpg">
            <hr>
            <p>
              The Geographical and Environmental Science Society is a student based society of the Department of
              Geography, University of Ruhuna. It was initiated at the Department of Geography in 1980 under the
              University Act No. 134. The Society usually organizes public awareness programs, seminars, workshops and
              field excursions for sharing knowledge among students.
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>To create a platform to publish the research findings of the students</li>
              <li>To organize awareness programs on environment for students and outsiders</li>
              <li>To make arrangements for annual publications such as the “VISHWAYA” Journal</li>
            </ul>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Office Bearers</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>Advising Committee</b>
                    <figure class="professor-description">
                      Professor P. Hewage
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>President</b>
                    <figure class="professor-description">T. M. M. Pushpakumara</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Secretary</b>
                    <figure class="professor-description">H.A.I.L.De Maduwanthi</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice President</b>
                    <figure class="professor-description">A. H. D. I. Sandeepani</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice Secretary</b>
                    <figure class="professor-description">D. P. D. Disanayake</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Treasurer</b>
                    <figure class="professor-description">Dr. S. L. J. Fernando</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Treasurer</b>
                    <figure class="professor-description">W.Dhamith de Silva</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Editor</b>
                    <figure class="professor-description">Mr. Palitha Amaraweera</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Editor</b>
                    <figure class="professor-description">
                      W.P.I. Madubhashini<br>
                      L. L. B. Bhagya<br>
                      W. C. Ranasingha<br>
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Committee Members</b>
                    <figure class="professor-description">
                      S. U. Nadeeshani<br>
                      T. G. Gayani Kaushalya<br>
                      P. Akalanka<br>
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
